<template>

  <div class="tip">

    <div class="top" @click="gotop()">
      <img src="../../static/img/dn-10.png" class="icon"/>
    </div>

    <!-- <div class="phone">
      <img src="../../static/img/dn-11.png" />
    </div> -->
    <div class="phone" v-on:mouseover="open()" v-on:mouseout="close()">
      <img src="../../static/img/dn-11.png" class="icon"/>
      <div class="drawer">
        <div class="setbox" :class="{show: isshow}">
          <div><img src="../../static/img/dnx-11.png" class="icon" /></div>
          <div>{{rightList.context1}}</div>
        </div>
      </div>
    </div>
    <div class="qrcode" v-on:mouseover="qropen()" v-on:mouseout="qrclose()">
      <img src="../../static/img/dn-12.png" class="icon" />
      <div class="drawer1">
        <div class="setbox" :class="{show: qrshow}">
          <div class="flex">
            <div><img src="../../static/img/dnx-12.png" class="icon" /></div>
            <div class="kefu">在线客服</div>
          </div>
          <div class="code"><img :src="rightList.logo" class="qrcode qrcodeimg"/></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
    },
    data() {
      return {
        isshow: false,
        qrshow:false,
        rightList:[]
      };
    },
    mounted() {
      this.getInfo()
      window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed() {
      window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
      getInfo() {
        this.$http
          .get("deno/api/publicity/info", {
            params: {
              title: '右侧-组件',
            }
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.rightList = response.data.data;
              }
            }.bind(this)
          )
      },
      scrollToTop() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        this.scrolltop = scrollTop
      },
      gotop() {
        let timer = setInterval(() => {
          document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
          if (this.scrolltop === 0) {
            clearInterval(timer)
          }
        }, 15)
      },
      close() {
        this.isshow = false
      },
      open(){
        this.isshow = true
      },
      qrclose() {
        this.qrshow = false
      },
      qropen(){
        this.qrshow = true
      }
    },
  };
</script>
<style lang="stylus" scoped>
.tip
    position: fixed;
    right: 0;
    top: 50%;
    width: 40px;
    z-index: 99;
    .top,.phone,.qrcode
      cursor pointer
      width 40px
      background-color: #333;
      margin: 0;
      padding: 0;
      height 40px
      margin-bottom 10px
      img.icon
        padding: 10px;
        width: 20px;
        height: 20px;
        line-height: 20px;
.qrcode
  margin-bottom 0
  position relative
.phone
  position relative
.drawer
  position absolute
  right 0
  top 0
  height: 40px;
  display:flex;
  display:-webkit-flex;
  flex-direction:column;  
  .setbox
    position:absolute;
    padding-right: 10px;
    display: flex;
    border-radius: 20px 0 0 20px;
    font-size: 14px;
    align-items center
    z-index:1000;
    top:0px;
    bottom:0px;
    height:40px;
    background:#ffda2a;
    box-shadow:0px 3px 12px rgba(0,0,0,0.12);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease; 
    right:-460px;
    div
      height 40px
      display: flex;
      align-items: center;
  .show
    right: 0;
.drawer1
  position absolute
  right 0
  top 0
  height: 40px;
  display:flex;
  display:-webkit-flex;
  flex-direction:column;  
  .setbox
    position:absolute;
    background: #ffda2a;
    padding-right: 10px;
    border-radius: 20px 0 0 0;
    font-size: 14px;
    z-index:1000;
    top:0px;
    bottom:0px;
    height:40px;
    box-shadow:0px 3px 12px rgba(0,0,0,0.12);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease; 
    right:-460px;
    .flex
      display: flex;
      align-items center
      div
        height 40px
        display: flex;
        align-items: center;
    .code
      border-left: 2px solid #ffda2a;
      border-bottom: 2px solid #ffda2a;
      background-color: #ffff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-right: 10px;
      padding-top: 10px;
  .show
    right: 0;
    img.qrcode
      background-color #fff
      width 100px
      height 100px
@media (min-width:1920px) 
  .tip
    width 80px
  .tip .top, .tip .phone, .tip .qrcode
    width: 80px;
    height: 80px;
    margin-bottom: 30px;
  .tip .top img.icon, .tip .phone img.icon, .tip .qrcode img.icon
    padding: 20px;
    width: 40px;
    height: 40px;
    line-height: 40px;
  .drawer .setbox,.drawer1 .setbox
    height 80px
  .drawer1 .setbox .flex div
    height 80px
  .drawer1 .show img.qrcode
    width 160px
    height 160px
    margin-bottom 15px
  .drawer .setbox,.kefu
    font-size 18px
</style>


// WEBPACK FOOTER //
// src/components/CallUs.vue